// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2lLcy","footer":"ModalError_footer__YMTwj"};